import React, { useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import "./UseCase.css";

const images = [
  {
    src: "images/usecase1.png",
    description:
      "Perfecting the fit can be challenging, with measuring inconsistencies and time-consuming adjustments. Our technology streamlines the process, ensuring accuracy, efficiency, and a seamless experience for made to measure businesses, helping them achieve the perfect fit every time."
  },
  {
    src: "images/usecase2.png",
    description:
      "We understand the challenges of traditional manufacturing—long lead times, excess inventory, and production inefficiencies. That’s why we embrace on-demand manufacturing, using AI-driven precision to create what you need, when you need it. By eliminating guesswork and waste, we help businesses streamline production, reduce costs, and deliver perfectly fitted products with speed and accuracy."
  },
  {
    src: "images/usecase3.png",
    description:
      "Ensuring a perfect fit for every team member is tough. Our technology delivers precise, consistent sizing, making uniform fitting faster, easier, and more reliable."
  }
];

const UseCase = () => {
  const [selectedIndex, setSelectedIndex] = useState(null);

  return (
    <div className="solution-page black-bg">
      <Header />
      <div className="container padding-top-xxl">
        <div className="row text-center">
          <div className="col-md-12 theme-color">
            <h2>How Our Technology Caters to You</h2>
            <p className="custom-para custom-font-md fw-light padding-top-sm">
              Versatile and adaptable to various use cases based on your business requirements.
            </p>
          </div>
        </div>
      </div>

      {/* Gallery row with all images in a single row */}
      <div className="gallery-row">
        {images.map((image, index) => {
          const isSelected = selectedIndex === index;
          return (
            <div
              key={index}
              className={`image-containers ${isSelected ? "expanded" : ""} ${
                index === 2 && isSelected ? "reverse" : ""
              }`}
              onClick={() => setSelectedIndex(isSelected ? null : index)}
            >
              {isSelected ? (
                <>
                  <div className="img-wrapper">
                    <img
                      src={image.src}
                      alt={`Slide ${index + 1}`}
                      className="expanded-img"
                    />
                  </div>
                  <div className="description position-relative">
                    <p>{image.description}</p>
                    <div className="button-wrapper">
                      <Link to="/contact">
                          <button type="button" className="survey-btn">
                            Contact Us
                          </button>
                      </Link>
                    </div>
                  </div>
                </>
              ) : (
                <div className="img-wrapper">
                  <img
                    src={image.src}
                    alt={`Slide ${index + 1}`}
                    className="collapsed-img"
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>

      <Footer />
    </div>
  );
};

export default UseCase;
